import { DescriptiveTag } from "atoms/tag/DescriptiveTag";
import { TextButton } from "atoms/text-button/TextButton";

export interface RetailProductHeaderProps {
  productBrand?: string;
  productName: string;
  isFeaturedProduct: boolean;
  onBrandClick?: () => void;
}

export const RetailProductHeader = ({
  productBrand,
  productName,
  isFeaturedProduct,
  onBrandClick,
}: RetailProductHeaderProps) => {
  const retailProductTag = isFeaturedProduct ? "Featured" : "";

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex w-[342px] flex-col items-center">
        {productBrand && (
          <TextButton
            variant="info"
            className="pl-0 pr-3 text-xs font-light uppercase underline"
            onClick={onBrandClick}
          >
            {productBrand}
          </TextButton>
        )}
        <div className="-mt-2 text-center font-serif text-h2 text-primary">
          {productName}
        </div>
      </div>
      <div className="mb-2">
        {retailProductTag && (
          <DescriptiveTag color="secondary" size="chip">
            {retailProductTag}
          </DescriptiveTag>
        )}
      </div>
    </div>
  );
};
